import { Link as RouterLink } from "react-router-dom";
import { APP_SLUGS } from "@app/portal-sdk";
import { AppCard, AppIconTile, Box, Button, EmptyState, PageHeader, Stack, Typography } from "@app/ui-kit";
import { APP_REGISTRY } from "../../apps/registry";

/** MNT-1: the applications with something BKDP maintains, in the order the client navigation orders applications. */
export const maintainedApps = () => APP_SLUGS.map((slug) => APP_REGISTRY[slug]).filter((d) => d && d.maintained);

/**
 * MNT-3: /admin/apps. One card per application that has anything BKDP maintains: its own mark and name, the same
 * AppIconTile the client navigation uses so it reads as the same application, the registry's sentence, and a count.
 * An application with nothing to maintain is not here (decision 3).
 */
export const AppsIndex = () => {
  const apps = maintainedApps();
  return (
    <Stack spacing={5}>
      <PageHeader eyebrow="Admin Console" title="Applications" subtitle="What BKDP maintains for each application, and every client reads. These rows belong to no client." />
      {apps.length === 0 ? (
        <EmptyState eyebrow="Applications" title="Nothing to maintain yet" description="No application declares anything BKDP maintains for it." />
      ) : (
        <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", md: "repeat(2, 1fr)", lg: "repeat(3, 1fr)" }, gap: 2 }} data-testid="maintained-apps">
          {apps.map((def) => (
            <AppCard key={def.slug} eyebrow="Application" title={def.name} subtitle={def.maintained!.sentence} icon={<AppIconTile icon={def.icon} color={def.iconColor} />}
              action={<Button component={RouterLink} to={`/admin/apps/${def.slug}`} size="small" variant="outlined" data-testid={`open-${def.slug}`}>Open</Button>} sx={{ height: "100%" }}>
              <Typography variant="body2" color="text.secondary" data-testid={`count-${def.slug}`}>
                {def.maintained!.things.length} maintained {def.maintained!.things.length === 1 ? "thing" : "things"}: {def.maintained!.things.map((t) => t.label).join(", ")}.
              </Typography>
            </AppCard>
          ))}
        </Box>
      )}
    </Stack>
  );
};
